import React, { useEffect } from "react";
// import { Player } from "@lottiefiles/react-lottie-player";
import { createPortal } from "react-dom";
import dynamic from "next/dynamic";

const Player = dynamic(
  () => import("@lottiefiles/react-lottie-player").then((mod) => mod.Player),
  { ssr: false }
);

export default function ShowLoadingModal({ show }) {
  // Disable scroll on mount, enable on unmount
  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden"; // Disable scrolling
    } else {
      document.body.style.overflow = ""; // Re-enable scrolling
    }

    return () => {
      document.body.style.overflow = ""; // Clean up in case component unmounts
    };
  }, [show]);

  if (!show) return null;

  return createPortal(
    <div className="fixed inset-0 bg-gray-900 bg-opacity-70 flex items-center justify-center z-50">
      <div className="bg-white p-3 md:p-8 rounded-lg w-[95%] md:w-[90%] max-w-2xl text-center border-[1px] shadow-lg  max-h-[90vh] overflow-y-auto scrollbar-hide">
        <h2 className="text-sm md:text-2xl font-semibold text-[#005F59]">
          Predicting Your Rank...
        </h2>
        <p className="mt-4 text-sm md:text-lg text-[#6F6F6F]">
          Analyzing your inputs and comparing with the past 3 years of NEET
          data...
        </p>
        <div className="mt-6">
          <Player
            autoplay
            loop
            src="assets/jsons/Opener Loading.json"
            style={{ height: "200px", width: "250px" }}
          />
        </div>
        <div className="mt-6 text-sm md:text-lg text-[#B7804A] text-left">
          Please hold tight as we:
          <ul className="text-left mt-2 ml-6">
            <li>Process your scores and category information</li>
            <li>Retrieve historical cutoff trends</li>
            <li>Generate your personalized rank prediction</li>
          </ul>
          <p className="mt-4 text-sm  md:text-lg text-black text-left">
            This may take a few moments. Thank you for your patience!
          </p>
        </div>
      </div>
    </div>,
    document.body
  );
}
